/** @format */

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Footer from "./components/Footer";
import * as serviceWorker from "./serviceWorker";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
let URLactual = window.location;
// console.log("URLactual", URLactual.pathname.toUpperCase().split("/")[1]);
ReactDOM.render(
  <React.StrictMode>
    <App />
    {URLactual.pathname.toUpperCase() === "/login".toUpperCase() ||
    URLactual.pathname.toUpperCase() ===
      "/recuperar-constrasenia".toUpperCase() ||
    URLactual.pathname.toUpperCase().split("/")[1] ===
      "recover-password".toUpperCase() ? null : (
      <Footer />
    )}
  </React.StrictMode>,
  document.getElementById("root")
);
serviceWorker.unregister();
serviceWorkerRegistration.register();
